import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScannerComponent } from '../scanner.component';

@Component({
  selector: 'cert-scanner-launcher',
  templateUrl: './scanner-launcher.component.html',
  styles: ``,
  standalone: false,
})
export class ScannerLauncherComponent {
  @Input() documentDescription!: string;
  @Input() documentCodeIds!: number[];
  @Output() returnContent = new EventEmitter<string>();

  constructor(private readonly modalService: NgbModal) {}

  launch() {
    const modal = this.modalService.open(ScannerComponent, {
      backdrop: 'static',
      size: 'xl',
      centered: true,
    });

    modal.result.then((result) => {
      if (result) {
        this.returnContent.emit(result.content);
      }
    });
  }
}
